export enum LeagueTableColumns {
  ExternalId = "externalId",
  Logo = "logo",
  LeagueId = "leagueId",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  RegionType = "regionType",
  AbbreviationLatin = "abbreviationLatin",
  AbbreviationLocal = "abbreviationLocal",
  CountryCode = "countryCode",
}
